import {Component, Input, OnInit} from '@angular/core';
import {PriceRobotProduct} from "../../../services/price-robot-product";
import {Lightbox} from "ngx-lightbox";

@Component({
    selector: '[app-price-robot-product-row]',
    templateUrl: './price-robot-product-row.component.html',
    styleUrls: ['./price-robot-product-row.component.scss']
})
export class PriceRobotProductRowComponent implements OnInit {
    @Input() product: PriceRobotProduct;

    constructor(private lightbox: Lightbox) {
    }

    ngOnInit(): void {
    }

    showImage(image: string) {
        this.lightbox.open([{
            downloadUrl: null,
            src: image,
            thumb: image,
            caption: ''
        }], 0);
    }
}
